import { Port } from 'features/Directory'
import { Resource } from 'service/Resource'

export interface SeaportsEndpoint extends Resource<Port, Port> {}

export const createSeaportsEndpoint = (http) => {
  return new Resource<Port, Port>('v1/seaports', http, undefined, true)
}
